import React from 'react';
import { CheckIcon } from '@heroicons/react/20/solid';

export interface Step {
  label: string;
}

interface StepIndicatorProps {
  steps: Step[];
  /** 1-based current step */
  currentStep: number;
}

export const StepIndicator: React.FC<StepIndicatorProps> = ({ steps, currentStep }) => {
  return (
    <nav aria-label='Progress'>
      <ol className='flex items-center'>
        {steps.map((step, index) => {
          const stepNumber = index + 1;
          const isCompleted = stepNumber < currentStep;
          const isCurrent = stepNumber === currentStep;

          return (
            <li key={index} className='flex items-center last:flex-none flex-1'>
              {/* Step dot + label */}
              <div className='flex flex-col items-center gap-1.5'>
                <div
                  className={`flex h-8 w-8 items-center justify-center rounded-full text-sm font-semibold transition-colors ${
                    isCompleted
                      ? 'bg-primary text-white'
                      : isCurrent
                        ? 'border-2 border-primary bg-primary/10 text-primary'
                        : 'border-2 border-gray-300 text-gray-400 dark:border-border-dark dark:text-dark-text-secondary'
                  }`}
                >
                  {isCompleted ? <CheckIcon className='h-4 w-4' /> : stepNumber}
                </div>
                <span
                  className={`text-xs font-medium whitespace-nowrap ${
                    isCompleted || isCurrent
                      ? 'text-primary'
                      : 'text-gray-400 dark:text-dark-text-secondary'
                  }`}
                >
                  {step.label}
                </span>
              </div>

              {/* Connector line */}
              {index < steps.length - 1 && (
                <div
                  className={`mx-3 mb-5 h-0.5 flex-1 rounded-full transition-colors ${
                    stepNumber < currentStep
                      ? 'bg-primary'
                      : 'bg-gray-200 dark:bg-dark-background-tertiary'
                  }`}
                />
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default StepIndicator;
